/**
 * @generated SignedSource<<8fb669c64ae422af6fdd9c7fbc87ef3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactTeamMemberUpdateInput = {
  contactId?: string | null;
  feeId?: string | null;
  teamMemberId?: string | null;
};
export type contactTeamMemberUpdateMutation$variables = {
  ID: string;
  input: ContactTeamMemberUpdateInput;
};
export type contactTeamMemberUpdateMutation$data = {
  readonly updateContactTeamMember: {
    readonly contactTeamMember: {
      readonly " $fragmentSpreads": FragmentRefs<"contactTeamMemberInlineFragment">;
    };
  };
};
export type contactTeamMemberUpdateMutation = {
  variables: contactTeamMemberUpdateMutation$variables;
  response: contactTeamMemberUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ID"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdBy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalRef",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactTeamMemberUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactTeamMemberPayload",
        "kind": "LinkedField",
        "name": "updateContactTeamMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactTeamMember",
            "kind": "LinkedField",
            "name": "contactTeamMember",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "contactTeamMemberInlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "teamMember",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fee",
                    "kind": "LinkedField",
                    "name": "fee",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "feeInlineFragment",
                        "selections": (v5/*: any*/)
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactTeamMemberUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactTeamMemberPayload",
        "kind": "LinkedField",
        "name": "updateContactTeamMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactTeamMember",
            "kind": "LinkedField",
            "name": "contactTeamMember",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "memberUserProfile",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Fee",
                "kind": "LinkedField",
                "name": "fee",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "683d4bfccc40a47a193660f2185492aa",
    "id": null,
    "metadata": {},
    "name": "contactTeamMemberUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation contactTeamMemberUpdateMutation(\n  $ID: ID!\n  $input: ContactTeamMemberUpdateInput!\n) {\n  updateContactTeamMember(id: $ID, input: $input) {\n    contactTeamMember {\n      ...contactTeamMemberInlineFragment\n      id\n    }\n  }\n}\n\nfragment contactTeamMemberInlineFragment on ContactTeamMember {\n  id\n  teamMember {\n    id\n    memberUserProfile {\n      firstName\n      lastName\n      id\n    }\n  }\n  fee {\n    ...feeInlineFragment\n    id\n  }\n}\n\nfragment feeInlineFragment on Fee {\n  id\n  name\n  amount\n  createdAt\n  createdBy\n  currencyCode\n  description\n  externalRef\n  type\n}\n"
  }
};
})();

(node as any).hash = "6a045816bbcbb62261a871975f972047";

export default node;
